import { writable } from "svelte/store";
import { AsyncReadable, AsyncStatus } from "./async-readable.js";

/**
 * Builds an AsyncReadable that will be reloaded when the `reload` function gets called
 */
export function manualReloadStore<T>(
  fn: () => Promise<T>
): AsyncReadable<T> & { reload: () => Promise<void> } {
  const store = writable<AsyncStatus<T>>({ status: "pending" });

  const reload = async () => {
    try {
      const value = await fn();
      store.set({
        status: "complete",
        value,
      });
    } catch (error) {
      store.set({ status: "error", error });
    }
  };

  reload();
  return {
    subscribe: store.subscribe,
    reload,
  };
}
